import { useState } from "react";

const Montre = () => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <label>Mot de passe :</label>
      <input
        type={showPassword ? "text" : "password"}
        placeholder="Entrez votre mot de passe"
        style={{ paddingRight: "30px" }} // Espace pour l'icône
      />
      {/* Icône d'œil */}
      <span
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
        }}
      >
        {showPassword ? "👁️" : "🙈"}
      </span>
    </div>
  );
};

export default Montre;
